const OverviewTheme = {
  components: {
    TreeSelect: {
      indentSize: 12,
    }
  }
}

export {
  OverviewTheme
}